import { defineComponent as _defineComponent } from 'vue'
import { computed, ComputedRef } from 'vue';

import Tenant from '@/data/datatypes/Tenant';
import { patternForApp } from '@/data/helpers/TaskHelper';
import { AppIdentDetails, MiniApp } from '@/data/tasks/MiniApp';

interface Props {
  userTenantId?: string;
  app: MiniApp | AppIdentDetails;
  tenants: Record<string, Tenant>;
  showAppName?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AppIdent',
  props: {
    userTenantId: null,
    app: null,
    tenants: null,
    showAppName: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { userTenantId?: string, app: MiniApp | AppIdentDetails, tenants: Record<string, Tenant>, showAppName: boolean }



const needsDefaultIdent: ComputedRef<boolean> = computed(() => {
  return !('pattern' in props.app);
});

const styleForApp: ComputedRef<Record<string, string> | undefined> = computed(() => {
  // The check for 'id' is to separate the behaviour for the 2 classes of psudo-app;
  // the old collaborate app and the psudo-apps in the calendar. It's possible for the
  // MiniApp to have an 'id' but not a 'pattern' E.g. the internal collab app, in which case
  // a pattern is derived from the object's properties.
  if ('id' in props.app || 'pattern' in props.app) {
    return {
      background: patternForApp(props.app as MiniApp).gradient
    };
  }
  return undefined;
});

const isExternalTenantApp: ComputedRef<boolean> = computed(() => {
  return !!props.app.tenantId && !!props.userTenantId && props.app.tenantId !== props.userTenantId;
});

function tenantName(tenantId: string, tenants: Record<string, Tenant>, verbose: boolean = false): string {
  const tenantName: string = tenants[tenantId]?.name ?? 'External tenant';
  return verbose ? `This App is shared from another tenant:\n${tenantName}` : tenantName;
}

return { __sfc: true,props, needsDefaultIdent, styleForApp, isExternalTenantApp, tenantName }
}

})